import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import { selectors as rootSelectors } from '../../root';

import Table from '../components/table/main';
//import createThreadForm from '../components/create-form/main';
import Search from '../../shared/search/main';
import Calendar from '../../shared/calendar/main';
import FilterStatuses from '../components/quick-filters/statuses/main';
import TableViewSwitch from  '../components/table-view-switch';

const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content ext-threads-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">
							{props.intl('List of external requests')}
						</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<TableViewSwitch {...props} />
							</div>
						</div>
						<div className="ui-control-bar__item modify-item---search">
							<div className="ui-control-bar__item-position">
								<Search
									form="threadsSearchForm"
									action={props.search}
									{...props}
									autoFocus={true}
									initialValues={props.searchData} />
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---filter">
							<div className="ui-control-bar__item-position">
								<FilterStatuses {...props} />
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">

								<button className="ui-btn ui-btn-primary apply" type="submit" onClick={props.apply}>
									{props.intl('Apply')}
								</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<Table {...props} />
				</div>
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		searchData: selectors.getSearchData(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state),
		statuses: selectors.getThreadStatuses(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		statusesFilters: selectors.getStatusesFilters(state),
		error: selectors.getError(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		requestQueryString: selectors.getRequestQueryString(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/list/main.js